export const mapValueMsg = {
  2: 'Incluir',
  3: 'Editar',
  4: 'Incluir',
};
